import { createRouter, createWebHistory } from "vue-router";

import SeeYouSoon from "./views/SeeYouSoon.vue";

const routes = [
  {
    path: "/signin",
    name: "SignIn",
    component: SeeYouSoon,
  },
  {
    path: "/create-user/:email",
    name: "CreateUser",
    redirect: '/signin',
  },
  {
    path: "/patient-dashboard",
    name: "PatientDashboard",
    redirect: '/signin',
  },
  {
    path: "/orders-dashboard",
    name: "OrdersDashboard",
    redirect: '/signin',
  },
  {
    path: "/patient-profile/:id",
    name: "PatientProfile",
    redirect: '/signin',
  },
  {
    path: "/delivery-address-confirm/:id",
    name: "DeliveryAddressConfirm",
    redirect: '/signin',
  },
  {
    path: "/credits-history/:id",
    name: "CreditsHistory",
    redirect: '/signin',
  },
  {
    path: "/edit-profile/:id",
    name: "EditProfile",
    redirect: '/signin',
  },
  {
    path: "/edit-user/:id",
    name: "EditUser",
    redirect: '/signin',
  },
  {
    path: "/create-assessment",
    name: "CreateAssessment",
    redirect: '/signin',
  },
  {
    path: "/create-assessment/:id/upload-images",
    name: "CreateAssessmentUploadImages",
    redirect: '/signin',
  },
  {
    path: "/paciente/:id/consulta/:assessmentId/pago",
    name: "AssessmentPaymentMethod",
    redirect: '/signin',
  },
  {
    path: "/paciente/:id/consulta/:assessmentId/enviar-seguimiento",
    name: "CreateFollowupAssessmentWithUser",
    redirect: '/signin',
  },
  {
    path: "/consulta/:id/cargar-imagenes",
    name: "CreateGuestAssessmentUploadImages",
    redirect: '/signin',
  },
  {
    path: "/previous-assessment/:id",
    name: "PreviousAssessment",
    redirect: '/signin',
  },
  {
    path: "/subscription-details/:id/:plan",
    name: "SubscriptionDetails",
    redirect: '/signin',
  },
  {
    path: "/assessments/:id/followup-assessment/:followupId/diagnosis",
    name: "FollowupAssessmentDiagnosisNew",
    redirect: '/signin',
  },
  {
    path: "/assessments/:id/followup-assessment/:followupId/edit",
    name: "EditFollowupAssessment",
    redirect: '/signin',
  },
  {
    path: "/assessments/:id/followup-assessment/:followupId/order-cart/:orderId/address",
    name: "FollowupOrderDeliveryAddress",
    redirect: '/signin',
  },
  {
    path: "/assessments/:id/followup-assessment/:followupId/order-cart/:orderId/confirm",
    name: "FollowupOrderReview",
    redirect: '/signin',
  },
  {
    path: "/edit-assessment/:id",
    name: "EditAssessment",
    redirect: '/signin',
  },
  {
    path: "/assessment-diagnosis-new/:id",
    name: "AssessmentDiagnosisNew",
    redirect: '/signin',
  },
  {
    path: "/assessment-diagnosis-new/:id/order-cart/:orderId/address",
    name: "OrderDeliveryAddress",
    redirect: '/signin',
  },
  {
    path: "/assessment-diagnosis-new/:id/order-cart/:orderId/confirm",
    name: "OrderReview",
    redirect: '/signin',
  },
  {
    path: "/delivery-address/:id",
    name: "DeliveryAddress",
    redirect: '/signin',
  },
  {
    path: "/assessment-messages/:id",
    name: "AssessmentMessages",
    redirect: '/signin',
  },
  {
    path: "/user-messages/:id",
    name: "UserMessages",
    redirect: '/signin',
  },
  {
    path: "/payment-method/:id",
    name: "PaymentMethod",
    redirect: '/signin',
  },
  {
    path: "/assessments/:id/followup-assessment/:followupId/payment-method",
    name: "FollowupPaymentMethod",
    redirect: '/signin',
  },
  {
    path: "/pharmacy-payment-method/:id",
    name: "PharmacyPaymentMethod",
    redirect: '/signin',
  },
  {
    path: "/pharmacy-payment-method-new/:id",
    name: "PharmacyPaymentMethodNew",
    redirect: '/signin',
  },
  {
    path: "/guest-payment-method/:id&&:password",
    name: "GuestPaymentMethod",
    redirect: '/signin',
  },
  {
    path: "/wire-transfer/:id",
    name: "WireTransfer",
    redirect: '/signin',
  },
  {
    path: "/assessments/:id/followup-assessment/:followupId/followup-wire-transfer",
    name: "FollowupWireTransfer",
    redirect: '/signin',
  },
  {
    path: "/pharmacy-wire-transfer/:id",
    name: "PharmacyWireTransfer",
    redirect: '/signin',
  },
  {
    path: "/pharmacy-wire-transfer-new/:id",
    name: "PharmacyWireTransferNew",
    redirect: '/signin',
  },
  {
    path: "/terminos-y-condiciones",
    name: "TermsConditions",
    redirect: '/signin',
  },
  {
    path: "/aviso-de-privacidad",
    name: "PrivacyNotice",
    redirect: '/signin',
  },
  {
    path: "/nuestros-especialistas",
    name: "MedicalSpecialists",
    redirect: '/signin',
  },
  {
    path: "/change-password",
    name: "ChangePassword",
    redirect: '/signin',
  },

  {
    path: "/payment-success",
    name: "PaymentSuccess",
    redirect: '/signin',
  },
  {
    path: "/pharmacy-payment-success",
    name: "PharmacyPaymentSuccess",
    redirect: '/signin',
  },
  {
    path: "/pharmacy-payment-success-new",
    name: "PharmacyPaymentSuccessNew",
    redirect: '/signin',
  },
  {
    path: "/followup-payment-success/:id",
    name: "FollowupPaymentSuccess",
    redirect: '/signin',
  },

  {
    path: "/subscription-success/:id",
    name: "SubscriptionSuccess",
    redirect: '/signin',
  },

  {
    path: "/cash-payments/:id",
    name: "CashPayments",
    redirect: '/signin',
  },
  {
    path: "/assessments/:id/followup-assessment/:followupId/followup-cash-payments",
    name: "FollowupCashPayments",
    redirect: '/signin',
  },
  {
    path: "/pharmacy-cash-payments/:id",
    name: "PharmacyCashPayments",
    redirect: '/signin',
  },
  {
    path: "/pharmacy-cash-payments-new/:id",
    name: "PharmacyCashPaymentsNew",
    redirect: '/signin',
  },
  {
    path: "/",
    // name: 'LandingPage',
    // component: LandingPage,
    name: "RootRedirect",
    redirect: '/signin',
  },

  /* {
    path: '/section1training',
    name: 'Section1Training',
    component: Section1Training,
  },

  {
    path: '/section2training',
    name: 'Section2Training',
    component: Section2Training,
  },

  {
    path: '/mockTest',
    name: 'MockTest',
    component: MockTest,
  },

  {
    path: '/scoreReportHistory',
    name: 'scoreReportHistory',
    component: scoreReportHistory,
  },

  {
    path: '/user-metrics',
    name: 'UserMetrics',
    component: UserMetrics,
  },

  {
    path: "/previous-exam/:mock_test_id",
    name: "PreviousExam",
    component: PreviousExam,
  },

  {
    path: "/user-profile",
    name: "UserProfile",
    component: UserProfile,
  },

  {
    path: "/change-password",
    name: "ChangePassword",
    component: ChangePassword,
  },

  

  {
    path: '/payment-plan',
    name: 'PaymentPlan',
    component: PaymentPlan,
  }, */
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
